import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { ContentProvider } from './contexts/ContentContext';
import HomePage from './pages/HomePage';
import AllEvents from './pages/AllEvents';
import AllMembers from './pages/AllMembers';
import AllGallery from './pages/AllGallery';
import AdminPage from './pages/AdminPage';
import EntryChoice from './components/EntryChoice';

function App() {
  const [selection, setSelection] = useState<string | null>(null);
  const isAdminPath = window.location.pathname.startsWith('/admin');

  if (selection === null && !isAdminPath) {
    return <EntryChoice onSelectAsimo={() => setSelection('asimo')} />;
  }

  return (
    <ContentProvider>
      <ThemeProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/events" element={<AllEvents />} />
              <Route path="/members" element={<AllMembers />} />
              <Route path="/gallery" element={<AllGallery />} />
              <Route path="/admin" element={<AdminPage />} />

              <Route path="/all-events" element={<Navigate to="/events" replace />} />
              <Route path="/all-members" element={<Navigate to="/members" replace />} />
              <Route path="/all-gallery" element={<Navigate to="/gallery" replace />} />
            </Routes>
          </div>
        </Router>
      </ThemeProvider>
    </ContentProvider>
  );
}

export default App;
